import { dataBucketName } from '../../../shared/customer-account.mjs';

// Display helpers shared by the customer sections and the fleet overview
// (moved out of CustomerDetail.jsx and Dashboard.jsx, portal workbench).

/** "just now", "5m ago", "3h ago", "yesterday", "4d ago". */
export function timeAgo(iso, now = Date.now()) {
  const diff = now - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return 'yesterday';
  return `${days}d ago`;
}

/**
 * The customer's data bucket: the stack output first (stored with the Qlik
 * integration), else the stack naming convention with the trust role's
 * account (ENTRAID-266).
 */
export function customerBucketName(customer) {
  if (!customer) return null;
  return customer.qlikBucketName ?? dataBucketName(customer);
}
